import React from "react";
import "./ServiceApplicationDetails.scss"
import ServiceApplicationDetails from "../../features/ServiceApplicationDetails/ServiceApplicationDetails";


const ServiceApplication = () => {
    return (
        <div className="page-container">
            <ServiceApplicationDetails />
        </div>
    );
};
export default ServiceApplication;
